import imageCompression from "browser-image-compression";

export default async function compressImage(imageFile) {
  console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

  const options = {
    maxSizeMB: 0.2,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  try {
    const compressedFile = await imageCompression(imageFile, options);
    console.log(compressedFile);

    return compressedFile;
  } catch (error) {
    console.log(error);
  }
}
